import { getCSRFToken } from '@front/utils/get-csrf-token';

const NEW_YASNO_HOST = 'new.yasno.live';
const NEW_YASNO_REF_COOKIE = 'new_yasno_ref';
const LOCAL_STORAGE_KEY = 'yasnorefs';
const MAX_SAVED_TRAILS = 200;

const isYasno = () => document.referrer.lastIndexOf('https://yasno.live', 0) === 0
  || document.referrer.lastIndexOf('https://beta.yasno.live', 0) === 0
  || document.referrer.lastIndexOf('https://demo.yasno.live', 0) === 0
  || document.referrer.lastIndexOf('http://localhost', 0) === 0;

// Returns true if logged in as client
const loggedIn = () => window.App?.user?.id && window.App?.user?.role && window.App.user.id !== '0' && window.App.user.role === 'client';

const getSavedTrails = () => JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || '[]');

const trackTrail = () => {
  // Ignore tracking for therapists
  if (window.App?.user?.role === 'therapist') {
    return;
  }

  // If referred from remote
  if (isYasno()) {
    return;
  }

  let referrer = document.referrer;

  if (!referrer && !new URLSearchParams(document.location.search).get('utm_source')) {
    return;
  }

  // YSN-8909
  if (referrer.includes(NEW_YASNO_HOST)) {
    const newYasnoRefCookie = document.cookie
      .split('; ')
      .find((row) => row.startsWith(NEW_YASNO_REF_COOKIE))
      ?.split('=')[1];

    if (newYasnoRefCookie) {
      referrer = newYasnoRefCookie;
      document.cookie = `${NEW_YASNO_REF_COOKIE}=; path=/; max-age=0;`;
    }
  }

  const trails = getSavedTrails();

  trails.push({
    d: Math.round(new Date().getTime() / 1000),
    u: document.location.href,
    r: referrer,
  });

  if (trails.length > MAX_SAVED_TRAILS) {
    trails.shift();
  }

  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(trails));
};

const flushTrails = () => {
  // Flush only for logged-in users
  if (!loggedIn()) {
    return;
  }

  const trails = getSavedTrails();

  if (!trails.length) {
    return;
  }

  fetch('/trails', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': getCSRFToken() || '',
    },
    body: JSON.stringify({ trails }),
  })
    .then((response) => {
      if (response.ok) {
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify([]));
      }
    })
    .catch(() => {
      // Silently fail on error
    });
};

document.addEventListener('DOMContentLoaded', () => {
  trackTrail();
  flushTrails();
});
